const PendingTileBlock = ({ count }: { count: number }) => (
  <div className="w-full bg-[#0085FF] px-[3px] py-[4px] rounded text-white">예약 {count}</div>
);

export default PendingTileBlock;
